import {useCallback, useEffect, useState} from 'react';
import {IconCopy, IconCalendarTime} from '../../../../assets/images';
import '../../../Layouts/CreateNewmeeting/CreateNewmeeting.scss';
import DatePicker from 'react-datepicker';
import '../../../../assets/scss/datepicker.scss';
import Store from '../../../../Store';
import {showModal} from '../../../../Actions/PopUp';
import SDK from '../../../SDK';
import {blockOfflineAction, getCallFullLink, getSiteDomain} from '../../../../Helpers/Utility';
import toastr from 'toastr';
import {toast} from 'react-toastify';
import {CALL_STATUS_CONNECTED, CALL_STATUS_RECONNECT} from '../../../../Helpers/Call/Constant';
import {useSelector} from 'react-redux';
import {callIntermediateScreen} from '../../../../Actions/CallAction';
import {getLocalUserDetails} from '../../../../Helpers/Chat/User';
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from '../../../../ui/Dialog';
import Button from '../../../../ui/Button';
import styles from './index.module.scss';
import {useDispatch} from 'react-redux';
import {HIDE_MODAL} from '../../../../Actions/Constants';

export default function CallScheduling({
    handleShowCallScreen,
    handleMeetMsgeSend,
    header = 'Instant Meet',
    description = 'Copy the link or click to join the meeting',
    scheduleHeaderText = 'Schedule Meeting',
    onClose,
    showSchedule = true,
    open,
}) {
    const [instantMeeting, setInstantMeeting] = useState(true);
    const [showCalendar, setShowCalendar] = useState(false);
    const [dateTimeSelection, setDateTimeSelection] = useState(false);
    const [scheduleDate, setscheduleDate] = useState(new Date());
    const [scheduleMeetLink, setScheduleMeetLink] = useState('Loading...');
    const {data: conferenceData = {}} = useSelector(state => state.showConfrenceData || {});
    const {data: callData = {}} = useSelector(state => state.callIntermediateScreen || {});
    const {data: groupsMemberListData = {}} = useSelector(state => state.groupsMemberListData || {});
    const {data: activeChatData = {}} = useSelector(state => state.activeChatData || {});

    useEffect(() => {
        handleScheduleMeetLink();
    }, []);

    const handleCloseSchedulePopup = useCallback(() => {
        if (onClose) {
            onClose(false);
        } else {
            Store.dispatch(
                showModal({
                    open: false,
                    modelType: 'scheduleMeeting',
                }),
            );
        }
    }, [onClose]);

    useEffect(() => {
        const vcardData = getLocalUserDetails();
        const chatType = activeChatData.chatType;
        const userIngroup = groupsMemberListData?.participants?.find(profile => {
            return vcardData.fromUser === profile.userId;
        });
        if (chatType === 'groupchat' && groupsMemberListData?.groupJid === activeChatData.chatJid && !userIngroup) {
            handleCloseSchedulePopup();
        }
    }, [
        activeChatData.chatJid,
        activeChatData.chatType,
        groupsMemberListData?.groupJid,
        groupsMemberListData?.participants,
        handleCloseSchedulePopup,
    ]);

    const handleScheduleMeetLink = async () => {
        const response = await SDK.createMeetLink();
        if (response.statusCode === 200) {
            const meetLink = getCallFullLink(response.data);
            setScheduleMeetLink(meetLink);
        } else {
            toastr.warning(`Something went wrong`);
        }
    };

    const handleCopyLink = () => {
        if (scheduleMeetLink !== 'Loading...') {
            navigator.clipboard.writeText(scheduleMeetLink);
            toast.success(`Meeting link copied!`);
        }
    };

    const handleShowCalendar = () => {
        setInstantMeeting(!instantMeeting);
        setDateTimeSelection(!dateTimeSelection);
        setscheduleDate(new Date());
    };

    const ScheduledDateValidation = date => {
        const selectedDate = new Date(date);
        const currentDate = new Date();
        selectedDate.setSeconds(0, 0);
        currentDate.setSeconds(0, 0);
        return selectedDate >= currentDate;
    };

    const handleJoinMeet = async () => {
        if (blockOfflineAction() || scheduleMeetLink === 'Loading...') return;
        const callLink = scheduleMeetLink.split(`${getSiteDomain()}/`)[1];

        if (
            callData &&
            (conferenceData.callStatusText === CALL_STATUS_CONNECTED ||
                conferenceData.callStatusText === CALL_STATUS_RECONNECT)
        ) {
            const roomLink = await SDK.getCallLink();
            if (scheduleMeetLink.includes(roomLink.data)) {
                handleCloseSchedulePopup();
                handleShowCallScreen();
            } else {
                handleCloseSchedulePopup();
                Store.dispatch(
                    showModal({
                        open: true,
                        modelType: 'CallConfirm',
                        newCallLink: callLink,
                    }),
                );
            }
        } else {
            handleCloseSchedulePopup();
            Store.dispatch(callIntermediateScreen({show: true, link: callLink}));
        }
    };

    const localHandleMeetMsgeSend = () => {
        if (!handleMeetMsgeSend) {
            toastr.warning('Unable to schedule meeting. Please try again.');
            return;
        }

        if (ScheduledDateValidation(scheduleDate)) {
            handleMeetMsgeSend({
                scheduledDateTime: new Date(scheduleDate).getTime(),
                scheduleMeetLink,
                meetingTitle: '',
            });
            handleCloseSchedulePopup();
        } else {
            toastr.warning(`Please check your selected date and time`);
        }
    };
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch({
            type: HIDE_MODAL,
        });
    };

    return (
        <Dialog open={open} onOpenChange={onClose ?? handleClose}>
            <DialogContent className={styles.container}>
                <DialogHeader>
                    <DialogTitle>{dateTimeSelection ? scheduleHeaderText : header}</DialogTitle>
                    {instantMeeting && <DialogDescription>{description}</DialogDescription>}
                </DialogHeader>
                <div className={styles.inner_container}>
                    {instantMeeting && (
                        <div className={styles.instant_meeting}>
                            <div className={styles.input_wrapper}>
                                <span className={styles.link}>{scheduleMeetLink}</span>
                                {scheduleMeetLink !== "Loading..." && (
                                    <Button
                                        variant='link'
                                        className={styles.copy_btn}
                                        type="button"
                                        onClick={handleCopyLink}
                                    >
                                        <IconCopy />
                                    </Button>
                                )}
                            </div>
                        </div>
                    )}

                    {dateTimeSelection && (
                        <div className={styles.schedule_time_section}>
                            <h2 className={styles.subheading}>Select Time &amp; Date</h2>
                            <div className={styles.calendar_time}>
                                <DatePicker
                                    selected={scheduleDate}
                                    onChange={setscheduleDate}
                                    minDate={new Date()}
                                    timeInputLabel="Time:"
                                    dateFormat="dd/MM/yyyy h:mm aa"
                                    showTimeInput
                                    open={showCalendar}
                                    readOnly
                                />
                                <Button
                                    className={styles.calendar_icon}
                                    variant="ghost"
                                    size="sm"
                                    onClick={() => setShowCalendar(!showCalendar)}
                                >
                                    <IconCalendarTime />
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles.footer}>
                    {showSchedule && (
                        <Button
                            disabled={scheduleMeetLink === 'Loading...'}
                            onClick={handleShowCalendar}
                            variant={dateTimeSelection ? 'secondary' : 'outline'}
                            className={styles.join_meeting_button}
                        >
                            {dateTimeSelection ? 'Back' : 'Schedule'}
                        </Button>
                    )}
                    {instantMeeting ? (
                        <Button
                            disabled={scheduleMeetLink === 'Loading'}
                            onClick={handleJoinMeet}
                            className={styles.join_meeting_button}
                            size="lg"
                            variant="primary"
                        >
                            Join Meeting
                        </Button>
                    ) : (
                        <Button
                            className={styles.join_meeting_button}
                            onClick={localHandleMeetMsgeSend}
                            size="lg"
                            variant="primary"
                            // disabled={!targetUserIds||targetUserIds.length===0}
                        >
                            Schedule Meeting
                        </Button>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}
